import { NgZone } from '@angular/core';

import { PUSH_HANDLER } from './push-handler';
import { WebPushHandlerService } from './web-push-handler.service';
import { CapacitorPushHandlerService } from './capacitor-push-handler.service';
import { Router } from '@angular/router';

import { LoggerService } from '../logger/logger.service';
import { StorageService } from '../app-state/storage.service';
import { AppStateService } from '../app-state/app-state.service';

function pushHandlerFactory(ngZone: NgZone, router: Router, logger: LoggerService, appStateService: AppStateService) {
  if (window['kgrCapacitor']) {
    return new CapacitorPushHandlerService(logger, ngZone, router, appStateService);
  } else {
    return new WebPushHandlerService(logger);
  }
}

export function providePushHandlerFactory() {
  return {
    provide: PUSH_HANDLER,
    useFactory: pushHandlerFactory,
    deps: [NgZone, Router, LoggerService, AppStateService],
  };
}
